import { handleRequest } from "../utilities/requestHandler";
import { authHeader, isTokenExpired } from "../utilities/globalServiceUtils";
import { triggerSessionExpired } from "./customHTTP";

export const fetchModelAsset = async (url, options = {}) => {
    const token = localStorage.getItem("token");
    if (token && isTokenExpired(token)) {
        triggerSessionExpired();
        throw new Error("Session expired");
    }

    const response = await fetch(url, {
        ...options,
        headers: {
            ...(options.headers || {}),
            ...authHeader(),
        },
    });
    if (response.status === 401) triggerSessionExpired();
    return response;
};

export const process2DModelFile = (requestData) => 
    handleRequest("post", "/models/process-2d-modelfile", requestData);

export const processModelFile = (requestData) => 
    handleRequest("post", "/models/process-modelfile", requestData);

/**
 * HEADs a model asset URL to see whether it exists.
 *
 * The Bearer token is attached because the URLs passed here live under /stock-models and /models,
 * which are served outside the axios instance and now require a session. Without it every caller
 * would read a 401 as "the model does not exist" and silently hide working models. Fixed here
 * rather than at the five call sites (MachineCard, ModelButton, MultipleModelViewer, Products,
 * SingleProduct) so they all benefit.
 *
 * @param {string} url Absolute asset URL to probe. Falsy input short-circuits to false.
 * @returns {Promise<boolean>} True only on a 2xx response; false on any error or non-2xx.
 */
export const verifyResourceExists = async (url) => {
    if (!url) return false;
    try {
        const response = await fetchModelAsset(url, { method: "HEAD" });
        return response.ok;
    } catch (err) {
        console.error("Failed to verify resource:", err);
        return false;
    }
};

/**
 * Ask the server which GLB models contain a part, by scanning their BOM JSON on disk.
 *
 * @param {Object} args
 * @param {string} args.product_number Part number to look for.
 * @param {Array<string>} args.filenames GLB filenames without extension.
 * @returns {Promise<Object>} `{ status, data: { [filename]: true | false | null } }` envelope.
 */
export const findModelsContainingPart = ({ product_number, filenames }) =>
    handleRequest("post", "/models/models-containing-part", { product_number, filenames });
